import moment from "moment";
import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { useDispatch, useSelector } from "react-redux";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import { toast } from "react-toastify";
import { get } from "lodash";
import MBOForm from "./MBOForm";
import { isMobile } from "react-device-detect";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const dispatch = useDispatch();
  const [dynamicFieldsError, setDynamicFieldsError] = useState("");

  const [formData, setFormData] = useState({
    target1: "",
    target2: "",
    target3: "",
    target4: "",
  });
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const availableYears = [currentYear, currentYear + 1, currentYear + 2];
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [terms, setTerms] = useState("");
  const [priceList, setPriceList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [distributorsList, setDistributorsList] = useState([]);
  const [emergencyContactError, setEmergencyContactError] = useState(false);
  const [alignmentClass, setAlignmentClass] = useState(
    "border-end text-center"
  );
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);
  console.log("uesrProfile", userProfile);

  const isRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Regional_Sales_Manager_permissions"
  );

  const isSrRsm = utils.hasPermission(
    primaryMenuRes,
    "Sales Target",
    "sales_target.Sr_Regional_Sales_Manager_permissions"
  );

  const fields = [
    {
      label: "Name",
      value: `${userProfile?.firstName} ${userProfile?.lastName}`,
    },
    {
      label: "Reporting Manager Name",
      value: userDetails?.reporting_manager_nm,
    },
    {
      label: "Sr. RSM/RSM",
      value: userDetails?.rsm_nm ?? "No Rsm",
    },
    {
      label: "Date",
      value: moment(userDetails.join_date).format("DD-MM-YYYY"),
    }, // Current Date
    { label: "Location", value: userDetails?.location || "Unknown" },
  ];

  useEffect(() => {
    getEmpDetails();
  }, []);

  useEffect(() => {
    // Update the alignment class based on whether it's mobile or not
    if (isMobile) {
      setAlignmentClass(""); // No text-center on mobile devices
    }
  }, []); // This runs once after the component mounts

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const getEmpDetails = () => {
    utils
      .callAPI("get", `/sales/emp_details`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setUserDetails(res);
        } else {
          setUserDetails([]);
        }
      })
      .catch((err) => {
        setUserDetails([]);
      });
  };

  const getTerms = (id) => {
    var bodyFormData = new FormData();

    bodyFormData.append("id", id === "none" ? "" : id);

    utils
      .callAPI("post", `/sales/getQuotationTerms`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setFormData((prevFormData) => ({
            ...prevFormData,
            termsAndConditions: res.contents, // Assuming res is the terms string received from API
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            termsAndConditions: "", // Set to default if res is undefined or empty
          }));
        }
      })
      .catch((err) => {
        setFormData((prevFormData) => ({
          ...prevFormData,
          termsAndConditions: "", // Set to default if API call fails or res is undefined
        }));
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Regular expression to check if the input contains only digits
    const isOnlyDigits = /^\d*$/.test(value); // Allows an empty value or digits only

    // Only update formData if the value contains only digits
    if (isOnlyDigits) {
      setFormData({
        ...formData,
        [name]: value, // Update the value if it contains only digits
      });
    }
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      // if (isEdit) {
      //   bodyFormData.append("id", props?.rowData?.id);
      // }
      bodyFormData.append("quarter_1", formData.target1);
      bodyFormData.append("quarter_2", formData.target2);
      bodyFormData.append("quarter_3", formData.target3);
      bodyFormData.append("quarter_4", formData.target4);
      bodyFormData.append("year", selectedYear);
      bodyFormData.append("yearly", caluclateTotal());

      utils
        .callAPI("post", "/sales/addMboForm", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  const getQuotationList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("userId", userProfile?.id);
    bodyFormData.append("id", "");
    bodyFormData.append("vendor_type", "Distributor");
    bodyFormData.append("page", "");
    bodyFormData.append("per_page", "");

    utils
      .callAPI("post", `/sales/getsalesFormList`, bodyFormData)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistributorsList(res.result);

          // console.log(
          //   "Yeh hai company",
          //   res.result.map((company) => company.companyName)
          // );
        } else {
          setDistributorsList([]);
        }
      })
      .catch((err) => {
        setDistributorsList([]);
      });
  };

  const caluclateTotal = () => {
    const { target1, target2, target3, target4 } = formData;

    return (
      (parseFloat(target1) || 0) +
      (parseFloat(target2) || 0) +
      (parseFloat(target3) || 0) +
      (parseFloat(target4) || 0)
    );
  };
  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Add"}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col className=" border-top border-start border-end p-2 text-center">
                <h4>
                  Vura MBO Form -{" "}
                  <RB.Form.Select
                    value={selectedYear}
                    onChange={handleYearChange}
                    className="d-inline w-auto ms-2" // Make dropdown inline with heading
                  >
                    {availableYears.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </RB.Form.Select>
                </h4>
              </RB.Col>
            </RB.Row>

            {fields.map((field, index) => (
              <RB.Row key={index} className=" border border-bottom-0">
                <RB.Col
                  className={`px-2 py-1 py-md-2  ${alignmentClass}`}
                  md={4}
                >
                  {field.label}
                </RB.Col>
                <RB.Col className="px-2 py-1  py-md-2" md={8}>
                  {field.value}
                </RB.Col>
              </RB.Row>
            ))}

            <RB.Row>
              <RB.Col className=" border-top border-start border-end p-2 text-center">
                <h4>Sales Target</h4>
              </RB.Col>
            </RB.Row>

            <RB.Row className="border border-bottom-0">
              <RB.Col
                className={` p-1  d-flex justify-content-center align-items-center ${alignmentClass}`}
                md={4}
              >
                <h4>Period</h4>
              </RB.Col>
              <RB.Col className="  text-center p-1" md={8}>
                <h4>Target in Values</h4>
                <p>
                  (Put values in lakhs only, e.g. - if your target is 1 CR, you
                  have to write 100)
                </p>
              </RB.Col>
            </RB.Row>

            <MBOForm
              formData={formData}
              handleInputChange={handleInputChange}
              isMobile={isMobile}
            />
            <RB.Row className="border">
              <RB.Col
                className={`p-2 p-md-4  d-flex justify-content-md-center align-items-md-center ${alignmentClass}`}
                md={4}
              >
                Yearly Target
              </RB.Col>
              <RB.Col
                className="   text-left d-flex  align-items-center p-1 ps-4 ps-md-4 "
                md={8}
              >
                {caluclateTotal()}
              </RB.Col>
            </RB.Row>

            <RB.Row className="align-items-center mt-4">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
